export default function (oneMixin) {

  var targetMixin = (superInstance, ...args) => {
    //执行构造函数
    oneMixin.apply(superInstance, args);

    //拷贝方法过去
    copyProperties(superInstance, oneMixin.prototype);

    return superInstance;
  }

  //静态方法
  copyProperties(targetMixin, oneMixin);
  return targetMixin;
}

function copyProperties(target, source) {
  for (var key in source) {
    if (key !== "constructor"
      && key !== "prototype"
      && key !== "name"
    ) {
      if (target[key]) {
        console.error(`${key} has already existed in `, target);
      }
      let desc = Object.getOwnPropertyDescriptor(source, key);
      Object.defineProperty(target, key, desc);
    }
  }
}
